import { useState } from "react";
import { FiArrowUpRight } from "react-icons/fi";
import { submitOutreach } from "../../lib/outreach";
import "./Contact.css";

function Contact() {
  const [sent, setSent] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    submitOutreach(Object.fromEntries(new FormData(e.target)));
    setSent(true);
  };

  return (
    <section className="contact" id="contact">
      <div className="contact__inner">
        <div className="contact__intro">
          <div className="contact__label">Contact</div>
          <h2 className="contact__title">
            Let&rsquo;s<br />talk
          </h2>
          <p className="contact__sub">
            Building a DTC brand? Tell me where it&rsquo;s headed and
            what&rsquo;s in the way.
          </p>
        </div>

        <form className="contact__form" onSubmit={handleSubmit}>
          <div className="contact__row">
            <label className="contact__field">
              <span className="contact__field-label">Name</span>
              <input name="name" type="text" required autoComplete="name" />
            </label>
            <label className="contact__field">
              <span className="contact__field-label">Email</span>
              <input name="email" type="email" required autoComplete="email" />
            </label>
          </div>
          <label className="contact__field">
            <span className="contact__field-label">Brand or company (optional)</span>
            <input name="brand" type="text" autoComplete="organization" />
          </label>
          <label className="contact__field">
            <span className="contact__field-label">What are you working on?</span>
            <textarea name="message" rows={5} required />
          </label>
          <button type="submit" className="contact__submit">
            Send message <FiArrowUpRight />
          </button>
          {sent && (
            <p className="contact__note">
              Message delivery is still being set up — please check back soon.
            </p>
          )}
        </form>
      </div>
    </section>
  );
}

export default Contact;
